import { PassThrough } from '@primevue/core'
import { PrimeVuePTOptions } from 'primevue/config'

import { DropdownPassthroughConfig } from '@/components/Tailwind/Dropdown'
import { PaginatorPassthroughConfig } from '@/components/Tailwind/Paginator'
import { TablePassthroughConfig, ColumnPassThroughConfig } from '@/components/Tailwind/Table'
import {
  TabListPassThroughConfig,
  TabPanelsPassThroughConfig,
  TabPassThroughConfig
} from '@/components/Tailwind/Tabs'
import {
  CheckboxGroupPassthroughConfig,
  CheckboxPassthroughConfig
} from '@/components/Tailwind/Checkbox'
import { InputNumberPassthroughConfig } from '@/components/Tailwind/InputStepper'
import { GalleriaPassThroughConfig } from '@/components/Tailwind/ImageCarousel'
import { CascadeDropdownSinglePassthroughConfig } from '@/components/Tailwind/CascadingDropdown'
import { ButtonPassthroughConfig } from '@/components/Tailwind/Button'
import { SelectButtonPassthroughConfig } from '@/components/Tailwind/SegmentedControl'

const passthroughConfig: PassThrough<PrimeVuePTOptions> = {
  select: DropdownPassthroughConfig,
  datatable: TablePassthroughConfig,
  paginator: PaginatorPassthroughConfig,
  tab: TabPassThroughConfig,
  tablist: TabListPassThroughConfig,
  tabpanels: TabPanelsPassThroughConfig,
  column: ColumnPassThroughConfig,
  checkbox: CheckboxPassthroughConfig,
  checkboxgroup: CheckboxGroupPassthroughConfig,
  inputnumber: InputNumberPassthroughConfig,
  galleria: GalleriaPassThroughConfig,
  cascadeselect: CascadeDropdownSinglePassthroughConfig,
  button: ButtonPassthroughConfig,
  selectbutton: SelectButtonPassthroughConfig
}

export default passthroughConfig
